'use client';
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SidebarUpsellSlotsTemplate } from '#pplx/frontend/apps/ask/upsell-slots/sidebar/internal/SidebarUpsellSlotsTemplate.js';
import { useSidebarUpsellSlotPlan } from '#pplx/frontend/apps/ask/upsell-slots/sidebar/internal/useSidebarUpsellSlotPlan.js';
import { UPSELL_SLOT_ACCEPTED_LOCATIONS, UPSELL_SLOT_IDS, } from '#pplx/frontend/apps/ask/upsell-slots/UpsellSlotInventory.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import React from 'react';
const SidebarUpsellCard = Dynamic(async () => {
    const { SidebarUpsellCard } = await import('#pplx/frontend/apps/ask/upsell-slots/sidebar/internal/SidebarUpsellCard.js');
    return { default: SidebarUpsellCard };
});
const UpsellButton = Dynamic(async () => {
    const { UpsellButton } = await import('#pplx/frontend/apps/ask/upsells/handler-components/UpsellButton.js');
    return { default: UpsellButton };
});
const renderReadySidebarUpsell = (plan) => {
    return (_jsx(SidebarUpsellCard, { ...plan.render.props, primaryAction: _jsx(UpsellButton, { ...plan.actions.primaryCta, hideUpsell: plan.actions.hideUpsell }) }));
};
export const SidebarUpsellSlot = ({ callsite }) => {
    const plan = useSidebarUpsellSlotPlan({
        slotId: UPSELL_SLOT_IDS.sidebar,
        acceptedLocations: UPSELL_SLOT_ACCEPTED_LOCATIONS.sidebar,
        source: {
            source: 'sidebar',
            responseChannel: 'upsell_information',
            request: {},
        },
        callsite,
    });
    if (!plan.show) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(SidebarUpsellSlotsTemplate.Renderer, {}), _jsx(SidebarUpsellSlotsTemplate.Slot, { slot: "primary", children: renderReadySidebarUpsell(plan) })] }));
};
//# sourceMappingURL=SidebarUpsellSlot.js.map